<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">

        <div class="td-cnt-title">
            <i class="fal fa-file-lines dialog-icon"></i>
            <span class="te-title">{{'quotation.importTechnicalDescription' | translate}} </span>
        </div>

        <div class="td-cnt-body-iq">
            <teiasoft-grid [dataSet]="technicalDescriptionTemplates" style="width: 100%;"
                [columnsToShow]="gridColumnsToShow" [customIcoCols]="customIcoCols"
                (customIconClick)="customIconClick($event)" [showDeleteIcon]="true"
                (rowDeleteClick)="onRowDeleteClick($event)" [autoWidth]="true" >
            </teiasoft-grid>
        </div>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onCloseClick()" class="mr-5" [type]="'tb-cancel'"
                [text]="'commons.cancel' | translate" [isMobile]="isMobile">
            </teiasoft-button>
        </div>
    </div>
</div>
